import {
  GET_COMBO_STORE,
  GET_COMBO_STORE_SUCCESS,
  GET_COMBO_STORE_FAILURE,
} from "actions/Store/actionTypes";

const initialState = {
  getComboStoreLoading: false,
  objComboStore: [],
  comboStoreLoaded: false,
};

const getComboStore = (state, action) => ({
  ...state,
  getComboStoreLoading: true,
  comboStoreLoaded: true,
});

const getComboStoreSuccess = (state, action) => {
  return {
    ...state,
    getComboStoreLoading: false,
    comboStoreLoaded: true,
    objComboStore: action.payload,
  };
};

const getComboStoreFailed = (state, action) => ({
  ...state,
  getComboStoreLoading: false,
  objComboStore: [],
  comboStoreLoaded: true,
});
const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMBO_STORE:
      return getComboStore(state, action);
    case GET_COMBO_STORE_SUCCESS:
      return getComboStoreSuccess(state, action);
    case GET_COMBO_STORE_FAILURE:
      return getComboStoreFailed(state, action);
    default:
      return state;
  }
};

export default storeReducer;
